const apiErrorMappings = {
  name: { 'value is not unique': 'Nama Produk sudah terdaftar di sistem.' },
  product_type_id: {},
  sku: { 'value is not unique': 'SKU sudah terdaftar di sistem.' },
  description: {},
  uom: {},
  weight: {},
  volume: {},
  price: {},
}

export default apiErrorMappings
